import React, { useEffect, useState } from 'react';
import { SettingsType, UserType } from '../interfaces/SettingsType';
import ConfirmDialog from './ConfirmDialog';

interface EditPilotsProps {
  settings: SettingsType | undefined;
  updateSettings: (settings: SettingsType) => void;
}

const EditPilots: React.FC<EditPilotsProps> = ({
  settings,
  updateSettings,
}) => {
  const [users, setUsers] = useState<UserType[]>([]);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [editedUser, setEditedUser] = useState<UserType>();
  const [newUser, setNewUser] = useState<UserType>();
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    if (settings) {
      setUsers(settings.userList);
    }
  }, [settings]);

  const handleEditClick = (index: number) => {
    setEditingIndex(index);
    setEditedUser(users[index]);
  };

  const handleDeleteClick = () => {
    if (editedUser === undefined) return;
    const updatedUsers = users.filter(
      (user) => user.email !== editedUser.email
    );
    setUsers(updatedUsers);
    const sharedWithList = updatedUsers.map((user) => user.email);
    updateSettings({
      ...settings,
      userList: updatedUsers,
      sharedWithList: sharedWithList,
    } as SettingsType);
    handleCancelClick();
    setShowConfirm(false);
  };
  const handleSaveClick = () => {
    if (editingIndex !== null && editedUser && settings !== undefined) {
      const updatedUsers = [...users];
      updatedUsers[editingIndex] = editedUser;
      setUsers(updatedUsers);
      setEditingIndex(null);
      setEditedUser(undefined);
      const sharedWithList = updatedUsers.map((user) => user.email);
      updateSettings({
        ...settings,
        userList: updatedUsers,
        sharedWithList: sharedWithList,
      });
    }
  };

  const handleCancelClick = () => {
    setEditingIndex(null);
    setEditedUser(undefined);
  };

  const handleAddUser = async () => {
    if (newUser && users && settings !== undefined) {
      const updatedUsers = [...users, newUser];
      setUsers(updatedUsers);
      const tempUser: UserType = {
        prename: newUser ? newUser.prename : '',
        lastname: newUser ? newUser.lastname : '',
        email: '',
      };
      setNewUser(tempUser);
      updateSettings({ ...settings, userList: updatedUsers });
    }
  };
  return (
    <>
      <h3>Piloten</h3>
      <div className="email-list">
        {users.map((user, index) => (
          <div key={user.email} className="email-item">
            {editingIndex === index ? (
              <div className="edit-container">
                <input
                  type="text"
                  value={editedUser?.prename}
                  placeholder="Vorname"
                  onChange={(e) => {
                    if (editedUser) {
                      const tempUser: UserType = {
                        ...editedUser,
                        prename: e.target.value,
                      };
                      setEditedUser(tempUser);
                    }
                  }}
                  className="edit-input"
                />
                <input
                  type="text"
                  value={editedUser?.lastname}
                  placeholder="Nachname"
                  onChange={(e) => {
                    if (editedUser) {
                      const tempUser: UserType = {
                        ...editedUser,
                        lastname: e.target.value,
                      };
                      setEditedUser(tempUser);
                    }
                  }}
                  className="edit-input"
                />
                <input
                  type="text"
                  value={editedUser?.email}
                  placeholder="Email"
                  onChange={(e) => {
                    if (editedUser) {
                      const tempUser: UserType = {
                        ...editedUser,
                        email: e.target.value,
                      };
                      setEditedUser(tempUser);
                    }
                  }}
                  className="edit-input"
                />
                <button
                  onClick={handleSaveClick}
                  className="save-button-settings"
                >
                  Speichern
                </button>
                <button onClick={handleCancelClick} className="cancel-button">
                  Abbrechen
                </button>
                <button
                  className="modal-button material-icons delete-button"
                  onClick={() => {
                    setShowConfirm(true);
                  }}
                >
                  delete
                </button>
                {showConfirm && (
                  <ConfirmDialog
                    message="Willst du dieses Log wirklich unwiederuflich löschen?"
                    onConfirm={handleDeleteClick}
                    onCancel={() => setShowConfirm(false)}
                  />
                )}
              </div>
            ) : (
              <>
                <span className="email-text">
                  {user.prename && user.lastname
                    ? `${user.prename} ${user.lastname}`
                    : user.email}
                </span>

                <button
                  onClick={() => handleEditClick(index)}
                  className="edit-button"
                >
                  <span className="material-icons-settings">edit_square</span>
                </button>
              </>
            )}
          </div>
        ))}
      </div>
      <div className="add-email-container">
        <input
          type="text"
          value={newUser?.email}
          onChange={(e) => {
            const tempUser: UserType = {
              prename: newUser ? newUser.prename : '',
              lastname: newUser ? newUser.lastname : '',
              email: e.target.value,
            };
            setNewUser(tempUser);
          }}
          placeholder="Enter new email"
          className="add-email-input"
        />
        <button onClick={handleAddUser} className="add-email-button">
          Neuen Piloten hinzufügen
        </button>
      </div>
    </>
  );
};

export default EditPilots;
